import { ProductBuilderAction } from '.'
import { Product, productMediaCreateItem } from '../../product'
import { put, takeLatest, call, takeEvery } from 'redux-saga/effects'
import { api } from '../../../core'
import { productMediaCreateItemResponseDtoToProductParameterValueFile, ProductMediaCreateItemResponseDto, productMediaDeleteItem } from '../../product/api'
import { ProductParameterValue, ProductParameterValueFile, ProductParameter, ProductConfiguration } from '../../product/model'

export function* productBuilderFileDelete(action: {
    type: ProductBuilderAction,
    params: {
        productConfiguration: ProductConfiguration,
        productParameterKey: string,
        productParameterValueFile: ProductParameterValueFile
    }
}) {
    yield put({ type: 'PRODUCT_BUILDER_LOADING_BEGIN' })
    const nonce = window.wpSettings.nonce
    yield call(api, productMediaDeleteItem(action.params.productParameterValueFile.toString(), nonce))
    const config = { ...action.params.productConfiguration }
    const configValue = config[action.params.productParameterKey]
    if (configValue && configValue.length && configValue[0].filesUploaded && configValue[0].filesUploaded.length) {
        const fileUploadedIndex = configValue[0].filesUploaded.findIndex(it => it.id === action.params.productParameterValueFile.id)
        configValue[0].filesUploaded.splice(fileUploadedIndex)
        yield put({
            type: 'PRODUCT_BUILDER_CONFIGURATION_SET', params: {
                productConfiguration: config,
                productParameterKeepOpen: false
            }
        })
    }
    yield put({ type: 'PRODUCT_BUILDER_LOADING_END' })
}

export function* productBuilderFileDeleteWatch() {
    yield takeEvery('PRODUCT_BUILDER_FILE_DELETE', productBuilderFileDelete)
}

export function* productBuilderFileUpload(action: {
    type: ProductBuilderAction,
    params: {
        product: Product,
        productParameterKey: string,
        productParameterValueKey: string,
        files: File[]
    }
}) {
    yield put({ type: 'PRODUCT_BUILDER_LOADING_BEGIN' })
    const configParameter = action.params.product.configuration[action.params.productParameterKey]
    const configParameterValueIndex = configParameter.findIndex(it => it.key === action.params.productParameterValueKey)
    const configParameterValue = configParameter[configParameterValueIndex]
    if (!configParameterValue)
        throw new Error(`Product parameter value key ${action.params.productParameterValueKey} was not found in parameter ${action.params.productParameterKey}.`)
    const filesUploaded: ProductParameterValueFile[] = []
    for (let i = 0; i < action.params.files.length; i++) {
        const file = action.params.files[i]
        const formData = new FormData()
        formData.append('file', file)
        const nonce = window.wpSettings.nonce
        const result: ProductMediaCreateItemResponseDto = yield call(api, productMediaCreateItem(formData, nonce))
        filesUploaded.push(productMediaCreateItemResponseDtoToProductParameterValueFile(result))
    }
    const configParameterValueNew: ProductParameterValue = {
        ...configParameterValue,
        filesUploaded: filesUploaded
    }
    const configParameterNew: ProductParameterValue[] = [...configParameter]
    configParameterNew[configParameterValueIndex] = configParameterValueNew
    const configurationNew = { ...action.params.product.configuration }
    configurationNew[action.params.productParameterKey] = configParameterNew
    yield put(
        {
            type: 'PRODUCT_BUILDER_CONFIGURATION_SET', params: {
                productConfiguration: configurationNew,
                productParameterKeepOpen: false
            }
        })
    yield put({ type: 'PRODUCT_BUILDER_COST_CALCULATE', params: { product: action.params.product, productConfiguration: configurationNew } })
    yield put({ type: 'PRODUCT_BUILDER_LOADING_END' })
}

export function* productBuilderFileUploadWatch() {
    yield takeLatest('PRODUCT_BUILDER_FILE_UPLOAD', productBuilderFileUpload)
}
